import React from "react";
import { inject, observer } from "mobx-react";
import Error from "./Error";

//Bootstrap
import Form from "react-bootstrap/Form";

function Phone({ field, GlobalStore: { formik } }) {
  const { fieldname, label, max, min } = field;
  const { handleChange, handleBlur, values, touched, errors } = formik;
  return (
    <Form.Group controlId={fieldname}>
      <Form.Label>{label}</Form.Label>
      <Form.Control
        required
        type="tel"
        pattern="[0-9]*"
        maxLength={max[0]}
        minLength={min[0]}
        name={fieldname}
        onChange={handleChange}
        onBlur={handleBlur}
        value={values[fieldname]}
        isValid={touched[fieldname] && !errors[fieldname]}
        isInvalid={touched[fieldname] && !!errors[fieldname]}
      />
      <Error touched={touched[fieldname]} message={errors[fieldname]} />
    </Form.Group>
  );
}

export default inject("GlobalStore")(observer(Phone));
